<template lang="pug">
    v-stepper(v-model='myStepper' vertical='')
        v-stepper-step(:complete='myStepper > 1' step='1')
            | Selección Cartola 
            small adjuntar cartola
        v-stepper-content(step='1')
            v-card.mb-5( height='100px' flat)
                div.text-xs-center
                    v-btn(
                        :color="colors.info"
                        :loading="uploadingFile"
                        :disable="uploadingFile"
                        class='white--text'
                        @click="setOpenDialog"
                        large
                        )
                        | Subir cartola bancaria 
                        v-icon.ml-3 cloud_upload
            
        v-stepper-step(:complete='myStepper > 2' step='2') Selección Movimiento Bancario
        v-stepper-content(step='2')
            v-card.mb-5()
                v-text-field(v-model='search' append-icon='search' label='Buscar' single-line='' hide-details='')
                v-data-table(
                    v-model= "selected"
                    :headers="headers"
                    :items="records"
                    class= "elevation-1"
                    item-key="id"
                    select-all
                    :pagination.sync='pagination'
                    :search='search'
                    )
                    template(slot="headers" slot-scope="props")
                        tr
                            th
                                v-checkbox(:input-value='props.all' :indeterminate='props.indeterminate' primary='' hide-details='' @click.stop='toggleAll')
                            th(v-for='header in props.headers' :key='header.text' :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click='changeSort(header.value)')
                                v-icon(small='') arrow_upward
                                |             {{ header.text }}
                    template(slot="items" slot-scope="props")
                        tr(:active="props.selected" @click="props.selected = !props.selected")
                            td()  
                                v-checkbox(
                                    :input-value="props.selected"
                                    primary
                                    hide-details
                                )
                        td.text-xs-right {{props.item.bank_card_date}}
                        td.text-xs-right {{props.item.movement_detail}}
                        td.text-xs-right {{props.item.charge}}
                        td.text-xs-right {{props.item.deposit | mixFormatCurrency}}
                        //- td {{props.item.balance}}
                        td.text-xs-right {{props.item.document_number}}
                        td.text-xs-right {{props.item.branch_office}}
                        td.text-xs-right {{props.item.already_in_database}}
                        
            v-btn(color='primary' @click='validateMovement' v-show="selected.length>0") Validar Movimientos
            v-btn(flat='' @click.native='myStepper = 1' ) Volver Anterior       
        upload-file( ref="upload" @upload_accounting_bank="setRecords" )
</template>

<script>
import UploadFile from '@/components/upload/uploadFile'
import PurchaseInvoicePaidListCheckable from '@/views/purchaseInvoice/PurchaseInvoicePaidListCheckable'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import AccountBankService from '@/services/api/accountBank/'
import HeaderTable from './table/header.js'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils.js'
export default {
    name: 'add-accounting-bank-card',
    props: {},
    data: function() {
        return {
            openDialog: false,
            showInvoiceTable: false,
            myStepper: 1,
            selected: [],
            headers: HeaderTable,
            records: [],
            uploadingFile: false,
            pagination: {
                sortBy: 'bank_card_date',
            },
            search: '',
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /**
         *
         */
        setOpenDialog() {
            //this.openDialog = true
            this.$refs.upload.dialog = !this.$refs.upload.dialog
        },
        /**
         *
         */
        setRecords(event) {
            this.records = this.addFakeIdToRecords(event)
            this.records = [...this.changeFormatDateRecords(this.records)]
            this.records = [...this.changeFormatAlreadyInDataBase(this.records)]
        },
        /**
         * it's added to fake id for each records
         * cos' parameter doesn`t come in request.
         */
        addFakeIdToRecords(records) {
            let newRecords = records.map((record, index) => {
                let objAux = {}
                objAux = record
                objAux.id = index
                return objAux
            })
            return newRecords
        },
        /**
         *
         */
        changeFormatDateRecords(records) {
            return records.map(record => {
                console.log({record})
                record.bank_card_date = moment(record.bank_card_date).format(
                    'DD-MM-YYYY'
                )
                return record
            })
        },
        /**
         *
         */
        changeBackendFormatDateRecords(records) {
            return records.map(record => {
                console.log({record})
                record.bank_card_date = moment(record.bank_card_date).format(
                    'YYYY-MM-DD'
                )
                return record
            })
        },
        /**
         *
         */
        changeFormatAlreadyInDataBase(records) {
            return records.map(record => {
                record.already_in_database = record.already_in_database
                    ? 'Si'
                    : 'No'
                return record
            })
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  item    The item
         * @return     {<type>}  { description_of_the_return_value }
         */
        mapBankCardDate(item) {

            //
            item.bank_card_date = item
                .bank_card_date
                .split('-')
                .reverse()
                .join('-')

            // 
            return item
        },

        /**
         *
         */
        validateMovement() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Validar')
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'Validación',
                    '¿Estas seguro de validar Movimiento(s) seleccionado?'
                )
            )
        },
        /**
         *
         */
        waitingValidate() {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(
                    'info',
                    'Validando...',
                    'Enviando datos a la Base de datos.',
                    true
                )
            )
        },
        /**
         *
         */
        async submitRecords() {
            let recordsSelected = this.selected.map(this.mapBankCardDate)
            /*recordsSelected = this.changeBackendFormatDateRecords(
                recordsSelected
            )*/
            let response = await AccountBankService.upload(recordsSelected)
            this.responseSubmit(response)
        },
        /**
         *
         */
        responseSubmit(response) {
            let status = response.status
            switch (status) {
                case 200:
                    this.successResponse()
                    this.$router.push('/bank_payments')
                    break
                default:
                    this.errorResponse(response.message)
                    break
            }
        },
        /**
         *
         */
        successResponse() {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Cartola subida exitosamente',
                    false,
                    3600
                )
            )
        },
        /**
         *
         */
        errorResponse(message) {
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('error', 'Error', message))
        },
        /**
         *
         */
        toggleAll() {
            if (this.selected.length) this.selected = []
            else this.selected = this.records.slice()
        },
        /**
         *
         */
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
    },
    watch: {
        records(val) {
            if (val.length > 0) {
                this.myStepper = 2
            }
        },
        /**
         *
         */
        responseConfirm(val) {
            switch (val) {
                case 'Validar':
                    this.waitingValidate()
                    this.submitRecords()
                    break
                default:
                    break
            }
        },
    },
    components: {
        UploadFile,
        PurchaseInvoicePaidListCheckable,
    },
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setTitleTopBar('Agregar cartola bancaria')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('EXECUTE_IMPORT_BANK_CARD')) ctx.$router.push('/')
        })
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.iconHeight {
    font-size: 100px;
}
</style>